<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listExecutivePositions"
        :title-table="$t('Executive Positions')"
        module="executivePositionsSettingsModule"
        sort-name="nome"
        :add-permission="'ROLE_CARGO_INSERIR'"
        :view-permission="'ROLE_CARGO_CONSULTAR'"
        :edit-permission="'ROLE_CARGO_ATUALIZAR'"
        :delete-permission="'ROLE_CARGO_DELETAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormExecutivePosition
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormExecutivePosition from './forms/FormExecutivePosition.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormExecutivePosition,
  },
  computed: {
    ...mapState('executivePositionsSettingsModule', {
      listExecutivePositions: state => state.listExecutivePositions,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'nome',
        },
        {
          label: this.$t('Active'),
          field: 'ativo',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'executivePositionsSettingsModule/prepareToEditExecutivePositions',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
